import styled from 'styled-components';

export const Layout = styled.div`
  display: grid;
  height: 100vh;
  grid-template-areas:
    'snav tbar'
    'snav pnav'
    'snav main';
  grid-template-rows: 50px 50px auto;
  grid-template-columns: 50px auto;
  grid-gap: 5px;
`;

export const PageNavContainer = styled.div`
  grid-area: pnav;
  display: grid;
  height: 10vh;
  margin-left: 5px;
  margin-right: 10px;
  padding: 0px 5px;
  grid-template-areas: 'left right';
  grid-template-columns: auto auto;
`;

export const PageNavRightContainer = styled.div`
  grid-area: right;
  justify-self: right;
  align-self: center;
  margin-right: 40px;
  grid-template-areas: 'label ddown';
  grid-template-columns: auto auto;
  grid-gap: 10px;
  & select {
    grid-area: ddown;
    background-color: rgb(232, 240, 254) !important;
  }
`;

export const PageNavLeftContainer = styled.div`
  grid-area: left;
  justify-self: left;
  align-self: center;
  padding-left: 5px;
`;

export const MainContainer = styled.div`
  grid-area: main;
  display: flex;
  flex-direction: column;
  margin: 15px 0px 0px;
  padding: 0px 15px 15px;
  overflow-y: scroll;
  grid-row-gap: 2px;
`;
